<div class="innhold">
  <mat-toolbar color="primary" >
  <span>{{ "Last ned aksjeeierbok" | translate }}</span>
  <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <mat-slide-toggle [(ngModel)]="fullhistorikk" >{{ "Med historikk" | translate }}</mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
  <a mat-button mat-raised-button color="primary"
     href="{{url()}}" download="aksjeeierbok.xlsx" mat-dialog-close>{{ "Last ned" | translate }}</a>
</mat-dialog-actions>
</div>
